/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import useLocales from 'src/hooks/useLocales';
import Loader from 'src/components/loader/Loader';

import { IRentPayment } from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';
import { GetMonthName } from 'src/sections/common/GetMonthName';
import { ContractReport } from 'src/@types/Choqorak/MainTables/Contract/ContractInfo';
import { DateConverter } from 'src/sections/common/DateConverter';

type Props = {
  Report?: ContractReport;
};

export default function ContractInfoReportPDF({ Report }: Props) {
  const recordsPerPage = 35;
  const { translate } = useLocales();
  const [dirction, setDirection] = useState('ltr');

  const lang = localStorage.getItem('i18nextLng');

  useEffect(() => {
    if (lang === 'ps' || lang === 'dr') {
      setDirection('rtl');
    } else {
      setDirection('ltr');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dirction]);

  if (!Report || !Report.list || Report.list.length === 0) {
    return <Loader />;
  }

  const thStyle = `table-th-Attandence-Report text-[12px]`;

  const tdStyle = `table-td-Attandence-Report text-[11px]`;

  const width = 'w-[240mm]';

  const totalPages = Math.ceil(Report!.list.length / recordsPerPage);

  return (
    <>
      <div className="px-7">
        {Report.list.length > 0 ? (
          <>
            {/* Loop through pages */}
            {Array.from({ length: totalPages }).map((_, pageIndex) => (
              <div
                key={pageIndex}
                className={`${width} h-[297mm] mx-auto bg-white text-black`}
                dir={`${dirction}`}
              >
                <div className="page-break py-5 px-2">
                  <div className="border-[2px] border-black border-b-0 pt-4 pb-2">
                    <div className="flex justify-between items-center px-5">
                      {/* Left Logo */}
                      <div className="flex flex-col justify-center items-center text-center">
                        <img
                          src={require('src/assets/Choqorak/logo1.png')}
                          width="100"
                          height="100"
                          alt="logo1"
                        />
                      </div>

                      {/* Center Text */}
                      <div className="text-base text-center font-bold print:text-base">
                        <h3>چقرک مرکز پخش مواد خوراکی</h3>
                        <h3>گزارش قرارداد ها</h3>
                      </div>

                      {/* Right Logo */}
                      <div className="flex flex-col justify-center items-center text-center">
                        <img
                          src={require('src/assets/Choqorak/logo2.png')}
                          width="200"
                          height="400"
                          alt="logo2"
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <table className="table-style print:text-black">
                      <thead className=" bg-gray-600">
                        <tr className="w-full bg-gray-600 print:bg-gray-600">
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('RentPaymentPrint.No')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('contractsInfo.ContractNumber')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('contractsInfo.CustomerName')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('Shop.ShopCode')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('contractsInfo.FinalRentPerMonth')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('contractsInfo.TotalContractDurationRent')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('contractsInfo.TotalContractDurationPaidRent')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('contractsInfo.StartDate')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('contractsInfo.EndDate')}
                          </th>
                          <th scope="col" className={` ${thStyle}`} style={{ color: 'black' }}>
                            {translate('contractsInfo.Status')}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Report!.list
                          .slice(pageIndex * recordsPerPage, (pageIndex + 1) * recordsPerPage)
                          .map((record: any, index: number) => (
                            <tr
                              className={
                                record.absentOnly == 'Absent'
                                  ? 'bg-red-200'
                                  : record.holiday == 'Holiday'
                                    ? 'bg-gray-300'
                                    : 'bg-white'
                              }
                              key={index}
                              style={{ pageBreakInside: 'avoid' }}
                            >
                              <td className={`${tdStyle}`}>{pageIndex * recordsPerPage + index + 1}</td>
                              <td className={`${tdStyle}`}>{record.contractNumber}</td>
                              <td className={`${tdStyle}`}>{record.customerName}</td>
                              <td className={`${tdStyle}`}>{record.shopCode}</td>
                              <td className={`${tdStyle}`}>{record.finalRentPerMonth}</td>
                              <td className={`${tdStyle}`}>{record.totalContractDurationRent}</td>
                              <td className={`${tdStyle}`}>
                                {record.totalContractDurationPaidRent}
                              </td>
                              <td className={`${tdStyle}`}>
                                {<DateConverter date={record.contractStartDate} />}
                              </td>
                              <td className={`${tdStyle}`}>
                                {<DateConverter date={record.contractEndDate} />}
                              </td>
                              <td className={`${tdStyle}`}>{record.contractStatus}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Footer for each page */}
                  {/* <div
              className={`absolute bottom-5 w-[230mm] mx-auto border-t-2 border-black text-[8pt]`}
            >
              <div className="px-5 relative w-full mx-auto" dir="ltr">
                <div className="flex justify-center items-center w-full">
                  <img
                    src={require('src/assets/Choqorak/footer.png')}
                    width="500"
                    height="50"
                    alt="footer"
                  />
                </div>
              </div>
            </div> */}
                </div>

                {/* Show Summary ONLY on the Last Page */}
                {pageIndex === totalPages - 1 && (
                  <div
                    className={`${width} h-[297mm] mx-auto bg-white text-black`}
                    dir={`${dirction}`}
                  >
                    <div className="page-break py-5 px-2">
                      <div className="border-[2px] border-black border-b-0 pt-4 pb-2">
                        <div className="flex justify-between items-center px-5">
                          {/* Left Logo */}
                          <div className="flex flex-col justify-center items-center text-center">
                            <img
                              src={require('src/assets/Choqorak/logo1.png')}
                              width="100"
                              height="100"
                              alt="logo1"
                            />
                          </div>

                          {/* Center Text */}
                          <div className="text-base text-center font-bold print:text-base">
                            <h3>چقرک مرکز پخش مواد خوراکی</h3>
                            <h3>گزارش قرارداد ها</h3>
                          </div>

                          {/* Right Logo */}
                          <div className="flex flex-col justify-center items-center text-center">
                            <img
                              src={require('src/assets/Choqorak/logo2.png')}
                              width="200"
                              height="400"
                              alt="logo2"
                            />
                          </div>
                        </div>
                      </div>
                      {/* Summary Section */}
                      <div>
                        <h3 className="text-center text-xl font-bold border-4 border-black p-2">
                          {translate('Shop.Report.ReportSummary')}
                        </h3>
                        <table className="w-full border border-black text-left text-sm">
                          <thead>
                            <tr className="bg-gray-200">
                              <th className="px-4 py-2 font-bold border border-black text-center">
                                {translate('contractsInfo.TotalRecord')}
                              </th>
                              <th className="px-4 py-2 font-bold border border-black text-center">
                                {Report!.list.length}
                              </th>
                            </tr>
                          </thead>
                        </table>
                      </div>

                      {/* Footer Section */}
                      {/* <div
                        className={`print:fixed print:bottom-5 print:w-[230mm] print:mx-auto print:border-t-2 print:border-black text-[8pt] hidden print:block`}
                      >
                        <div className="px-5 relative w-full mx-auto" dir="ltr">
                          <div className="flex justify-center items-center w-full">
                            <img
                              src={require('src/assets/Choqorak/footer.png')}
                              width="500"
                              height="50"
                              alt="footer"
                            />
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </>
        ) : (
          <div className="flex justify-center items-center">
            {translate('ReceptionDashboard.NoRecordFound')}
          </div>
        )}
      </div>
    </>
  );
}
